import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import './styles.scss';

const ActivityIndicator: React.FC = () => {
  return (
    <div className="container">
      <CircularProgress />
    </div>
  );
};

export default ActivityIndicator;
